import styled from "styled-components";

export const ProjectContainer = styled.div`
  position: relative;
  width: 300px;
  height: auto;
  background: var(--background-color-main);
  margin: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 600px) {
    width: 100%;
    margin: 0;
  }

  &:after {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: #fff;
    z-index: -2;
    filter: blur(40px);
  }
  &:before {
    content: "";
    position: absolute;
    top: -2px;
    left: -2px;
    right: -2px;
    bottom: -2px;
    background: #fff;
    z-index: -2;
  }

  &:nth-child(even):after,
  &:nth-child(even):before {
    background: ${(props) =>
      props.borderColor === "primary"
        ? "linear-gradient(235deg,#777aff, #010615, #2196f3)"
        : props.borderColor === "secondary"
        ? "linear-gradient(235deg,#ff005e, #010615, #fbff00)"
        : "linear-gradient(235deg,#2196f3, #010615, #00bcd4)"};
  }
  &:nth-child(odd):after,
  &:nth-child(odd):before {
    background: ${(props) =>
      props.borderColor === "primary"
        ? "linear-gradient(235deg,#777aff, #010615, #2196f3)"
        : props.borderColor === "secondary"
        ? "linear-gradient(235deg,#ff005e, #010615, #fbff00)"
        : "linear-gradient(235deg,#2196f3, #010615, #00bcd4)"};
  }
`;
export const DescContainer = styled.div`
  padding: 20px;
  color: var(--text-primary-color);
`;
export const Glass = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 100%;
  display: block;
  background: rgba(255, 255, 255, 0.1);
  pointer-events: none;
`;
export const Title = styled.h2``;
export const Description = styled.p``;
export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`;

export const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-top: 20px;
  padding: 10px;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
`;
